import { StaffBranchesPage } from './pages/StaffBranchesPage';
import { StaffCareersPage } from './pages/StaffCareersPage';
import { StaffMenuEditPage } from './pages/StaffMenuEditPage';
import { StaffQuotesPage } from './pages/StaffQuotesPage';
import { StaffMenuPage } from './pages/StaffMenuPage';
import { MembershipPage } from './pages/MembershipPage';
import { StaffMembershipsPage } from './pages/StaffMembershipsPage';
import { StaffCustomersPage } from './pages/StaffCustomersPage';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { RequireAuth } from './components/RequireAuth';
import { RequireStaff } from './components/RequireStaff';
import { DriverSignupPage } from './pages/DriverSignupPage';
import { DriverJobsPage } from './pages/DriverJobsPage';
import { StaffDriversPage } from './pages/StaffDriversPage';
import { LoginPage, RegisterPage } from './pages/AuthPages';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { LoyaltyPage } from './pages/LoyaltyPage';
import { MenuPage } from './pages/MenuPage';
import { ChangePasswordPage, ForgotPasswordPage, ResetPasswordPage } from './pages/PasswordPages';
import { StaffBoardPage } from './pages/StaffBoardPage';
import { StaffLoyaltyPage } from './pages/StaffLoyaltyPage';
import { StaffSettingsPage } from './pages/StaffSettingsPage';
import { OrderDetailPage, OrdersPage, PaymentCallbackPage } from './pages/OrderPages';
import { AuthProvider } from './state/AuthContext';
import { BranchProvider } from './state/BranchContext';
import { CartProvider } from './state/CartContext';

export function App() {
  return (
    // basename matches Vite's base: the app is served from /order on the site.
    <BrowserRouter basename="/order">
      <AuthProvider>
        <BranchProvider>
        <CartProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<MenuPage />} />
              <Route path="cart" element={<CartPage />} />
              <Route path="login" element={<LoginPage />} />
              <Route path="register" element={<RegisterPage />} />
              <Route path="forgot-password" element={<ForgotPasswordPage />} />
              <Route path="reset-password" element={<ResetPasswordPage />} />
              <Route
                path="change-password"
                element={
                  <RequireAuth>
                    <ChangePasswordPage />
                  </RequireAuth>
                }
              />

              <Route
                path="checkout"
                element={
                  <RequireAuth>
                    <CheckoutPage />
                  </RequireAuth>
                }
              />
              <Route
                path="orders"
                element={
                  <RequireAuth>
                    <OrdersPage />
                  </RequireAuth>
                }
              />
              <Route
                path="loyalty"
                element={
                  <RequireAuth>
                    <LoyaltyPage />
                  </RequireAuth>
                }
              />

              {/* Drivers. Signup is open to any signed-in customer; approval to
                  actually carry an order is checked on the server, not here. */}
              <Route
                path="driver/signup"
                element={
                  <RequireAuth>
                    <DriverSignupPage />
                  </RequireAuth>
                }
              />
              <Route
                path="driver"
                element={
                  <RequireAuth>
                    <DriverJobsPage />
                  </RequireAuth>
                }
              />
              {/* Public: the plans are a shop window. The card needs an account. */}
              <Route path="membership" element={<MembershipPage />} />
              <Route
                path="staff/memberships"
                element={
                  <RequireStaff>
                    <StaffMembershipsPage />
                  </RequireStaff>
                }
              />
              <Route
                path="staff/menu"
                element={
                  <RequireStaff>
                    <StaffMenuPage />
                  </RequireStaff>
                }
              />
              <Route
                path="staff/branches"
                element={
                  <RequireStaff>
                    <StaffBranchesPage />
                  </RequireStaff>
                }
              />
              <Route
                path="staff/careers"
                element={
                  <RequireStaff>
                    <StaffCareersPage />
                  </RequireStaff>
                }
              />
              <Route
                path="staff/menu/edit"
                element={
                  <RequireStaff>
                    <StaffMenuEditPage />
                  </RequireStaff>
                }
              />
              <Route
                path="staff/quotes"
                element={
                  <RequireStaff>
                    <StaffQuotesPage />
                  </RequireStaff>
                }
              />
              <Route
                path="staff/customers"
                element={
                  <RequireStaff>
                    <StaffCustomersPage />
                  </RequireStaff>
                }
              />
              <Route
                path="staff/drivers"
                element={
                  <RequireStaff>
                    <StaffDriversPage />
                  </RequireStaff>
                }
              />

              {/* The shop's own screens. */}
              <Route
                path="staff"
                element={
                  <RequireStaff>
                    <StaffBoardPage />
                  </RequireStaff>
                }
              />
              <Route
                path="staff/loyalty"
                element={
                  <RequireStaff>
                    <StaffLoyaltyPage />
                  </RequireStaff>
                }
              />
              <Route
                path="staff/settings"
                element={
                  <RequireStaff>
                    <StaffSettingsPage />
                  </RequireStaff>
                }
              />
              <Route
                path="orders/:orderId"
                element={
                  <RequireAuth>
                    <OrderDetailPage />
                  </RequireAuth>
                }
              />
              <Route
                path="payment/callback"
                element={
                  <RequireAuth>
                    <PaymentCallbackPage />
                  </RequireAuth>
                }
              />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </CartProvider>
        </BranchProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
